import React, { useState } from 'react';
import { Camera, Check, Loader2, X } from 'lucide-react';

// Upload de UMA foto da Avaliação 360: sobe na hora (POST /upload-foto →
// SharePoint) e devolve a URL via callback. O "upload separado" (em vez de base64
// no submit) é o que permite o autosave/retomar sem perder fotos.
// (Espelha o FotoUpload do BSV; muda só o endpoint e o acento de cor do módulo.)
const API = '/api/operacional/aval360';
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('authToken')}` });

// Redimensiona a foto NO NAVEGADOR antes de subir: lado maior ≤ 1280px, JPEG
// qualidade 0.7. Evita foto de celular de 3–5 MB; devolve um Blob.
const MAX_LADO = 1280;
const redimensionar = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const img = new Image();
      img.onerror = reject;
      img.onload = () => {
        let { width, height } = img;
        if (width > height && width > MAX_LADO) {
          height = Math.round((height * MAX_LADO) / width); width = MAX_LADO;
        } else if (height > MAX_LADO) {
          width = Math.round((width * MAX_LADO) / height); height = MAX_LADO;
        }
        const canvas = document.createElement('canvas');
        canvas.width = width; canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        canvas.toBlob((blob) => resolve(blob || file), 'image/jpeg', 0.7);
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });

const FotoUpload = ({ url, onUrl, label, loja, chave, slot }) => {
  const [estado, setEstado] = useState('idle'); // idle | enviando | erro
  const enviar = async (file) => {
    if (!file) return;
    setEstado('enviando');
    try {
      let envio = file;
      try { envio = await redimensionar(file); } catch { /* mantém o original */ }
      const fd = new FormData();
      fd.append('foto', envio, 'foto.jpg');
      if (loja) fd.append('loja', loja);
      if (chave) fd.append('chave', chave);
      if (slot) fd.append('slot', slot);
      const r = await fetch(`${API}/upload-foto`, { method: 'POST', headers: auth(), body: fd });
      const data = await r.json();
      if (!r.ok) throw new Error(data?.message || 'Falha no upload.');
      onUrl(data.url);
      setEstado('idle');
    } catch (e) {
      setEstado('erro');
    }
  };
  const remover = () => { onUrl(''); setEstado('idle'); };

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <label style={{
        display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'pointer',
        padding: '6px 10px', borderRadius: 6, fontSize: 12, fontWeight: 700,
        border: '1px solid', borderColor: url ? '#cbd5e1' : '#cbd5e1',
        background: url ? '#f1f5f9' : '#fff', color: url ? '#334155' : '#475569',
      }}>
        {estado === 'enviando' ? <Loader2 size={14} className="spin" /> : url ? <Check size={14} /> : <Camera size={14} />}
        {label || (url ? 'Foto enviada' : 'Foto')}
        {estado === 'erro' && <span style={{ color: '#b91c1c' }}>erro</span>}
        {/* Sem `capture`: o celular abre o seletor nativo com as DUAS opções
            (tirar foto na hora OU escolher da galeria). */}
        <input type="file" accept="image/*" style={{ display: 'none' }}
          onChange={(e) => enviar(e.target.files?.[0])} />
      </label>
      {url && estado !== 'enviando' && (
        <button type="button" onClick={remover} title="Remover foto"
          style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 24, height: 24, padding: 0, cursor: 'pointer', borderRadius: 6,
            border: '1px solid #fecaca', background: '#fef2f2', color: '#b91c1c',
          }}>
          <X size={14} />
        </button>
      )}
    </span>
  );
};

export default FotoUpload;
